import dynamic from 'next/dynamic'

export const SectionOfContent = dynamic(() => import('./section-of-content'))
